import React from 'react';
import ErrorBoundary from '@components/common/Retry/ErrorBoundary';
import { NetworkPanelWrapper, PanelWrapper, Panel } from './styled';
import Duration from './Panels/Duration';
import ResponseCode from './Panels/ResponseCode';
import NetworkContext from './Panels/context';
import type { CommonTypes } from './Panels/helpers';

type AlertPanelProps = CommonTypes;

function AlertPanel({
  enableSSF,
  enableTimeSlice,
  onSelect,
  onResetCallback,
  formatter,
}: AlertPanelProps) {
  const networkValue = React.useMemo(
    () => ({
      enableSSF,
      enableTimeSlice,
      onResetCallback,
      onSelect,
      formatter,
    }),
    [enableSSF, enableTimeSlice, onResetCallback, onSelect, formatter],
  );
  return (
    <NetworkContext.Provider value={networkValue}>
      <ErrorBoundary>
        <NetworkPanelWrapper>
          <PanelWrapper>
            <Panel>
              <Duration />
            </Panel>
            <Panel>
              <ResponseCode />
            </Panel>
          </PanelWrapper>
        </NetworkPanelWrapper>
      </ErrorBoundary>
    </NetworkContext.Provider>
  );
}

export default AlertPanel;
